module.exports = {
  "country": "AT",
  "artist": "Cesár Sampson",
  "song": "Nobody but You",
  "year": "2018",
  "place": "3",
  "spotify": "41gxXNTTz6LNVY2LIKoRHn"
};